import './input.css'

// Asterisco vermelho que marca campo obrigatório — usar ao lado do texto do label.
function RequiredMark() {
    return <span className="required-mark" title="Campo obrigatório" aria-label="obrigatório">*</span>
}

export default RequiredMark
